import { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { BadgeMinus, BadgePlus, PlusCircleIcon } from 'lucide-react';

const AggregationSection = ({ aggrName, measures, action, widgetFormik }) => {
  const [selectedMeasures, setSelectedMeasures] = useState([]);
  const initiateData = () => {
    const selectedDimension = measures?.find(
      a =>
        a?.name ===
        widgetFormik.values?.report_group_by_aggr?.[aggrName]?.dimension
    );
    if (selectedDimension?.measures) {
      setSelectedMeasures(selectedDimension.measures);
    }
  };

  useEffect(() => {
    if (action !== 'create') {
      initiateData();
    }
  }, []);
  return (
    <>
      <div className="col-3">
        <span className="p-float-label">
          <Dropdown
            showClear
            filter
            id="aggrField"
            options={measures}
            optionLabel={'value'}
            className="w-full"
            disabled={action === 'view' ? true : false}
            value={
              measures?.find(
                a =>
                  a.name ===
                  widgetFormik?.values?.report_group_by_aggr?.[aggrName]
                    ?.dimension
              )?.value
            }
            onChange={event => {
              const selectedLabel = event.value;

              const fullObject = measures.find(
                item => item.value === selectedLabel
              );
              if (fullObject?.name) {
                setSelectedMeasures(fullObject?.measures);
                widgetFormik.setFieldValue('report_group_by_aggr', {
                  ...(widgetFormik?.values?.report_group_by_aggr || {}),
                  [aggrName]: {
                    groupName: fullObject?.firstLetter,
                    dimension: fullObject?.name,
                    measureName: fullObject?.value,
                    type: fullObject?.type,
                    meta: fullObject?.meta,
                    report_group_aggr_label: '',
                  },
                });
              } else {
                if (widgetFormik?.values?.report_group_by_aggr?.[aggrName]) {
                  const copy = widgetFormik?.values?.report_group_by_aggr || {};
                  delete copy[aggrName];
                  widgetFormik.setFieldValue('report_group_by_aggr', copy);
                }
              }
            }}
          />
          <label htmlFor="aggrField">Aggregate Field</label>
        </span>
      </div>

      {Array.isArray(selectedMeasures) &&
        selectedMeasures.length > 0 &&
        widgetFormik?.values?.report_group_by_aggr?.[aggrName] && (
          <>
            <div className="col-3">
              <span className="p-float-label">
                <Dropdown
                  showClear
                  id="aggrField"
                  options={selectedMeasures || []}
                  disabled={action === 'view' ? true : false}
                  optionLabel={option =>
                    option?.aggType
                      ? option.aggType.charAt(0).toUpperCase() +
                        option.aggType.slice(1)
                      : ''
                  }
                  className="w-full"
                  value={selectedMeasures.find(
                    e =>
                      e.name ===
                      widgetFormik.values?.report_group_by_aggr?.[aggrName]
                        ?.measureSummarizedBy
                  )}
                  onChange={event => {
                    if (event.value?.name) {
                      widgetFormik.setFieldValue('report_group_by_aggr', {
                        ...widgetFormik.values.report_group_by_aggr,
                        [aggrName]: {
                          ...widgetFormik?.values?.report_group_by_aggr[
                            aggrName
                          ],
                          measureSummarizedBy: event.value?.name,
                        },
                      });
                    } else {
                      if (
                        widgetFormik?.values?.report_group_by_aggr?.[aggrName]
                          ?.measureSummarizedBy
                      ) {
                        const copy =
                          widgetFormik?.values?.report_group_by_aggr || {};
                        delete copy[aggrName].measureSummarizedBy;
                        widgetFormik.setFieldValue(
                          'report_group_by_aggr',
                          copy
                        );
                      }
                    }
                  }}
                />
                <label htmlFor="summarizedBy">Summarized By</label>
              </span>
            </div>
            <div className="col-3">
              <span className="p-float-label">
                <InputText
                  className="w-full"
                  id="report_group_aggr_label"
                  value={
                    widgetFormik?.values?.report_group_by_aggr?.[aggrName]
                      ?.report_group_aggr_label
                  }
                  onChange={event => {
                    if (event?.target?.value) {
                      widgetFormik.setFieldValue('report_group_by_aggr', {
                        ...widgetFormik.values.report_group_by_aggr,
                        [aggrName]: {
                          ...widgetFormik?.values?.report_group_by_aggr[
                            aggrName
                          ],
                          report_group_aggr_label: event?.target?.value,
                        },
                      });
                    } else {
                      if (
                        widgetFormik?.values?.report_group_by_aggr?.[aggrName]
                          ?.report_group_aggr_label
                      ) {
                        const copy =
                          widgetFormik?.values?.report_group_by_aggr || {};
                        delete copy[aggrName].report_group_aggr_label;
                        widgetFormik.setFieldValue(
                          'report_group_by_aggr',
                          copy
                        );
                      }
                    }
                  }}
                  disabled={action === 'view' ? true : false}
                />
                <label htmlFor="report_group_aggr_label">Label</label>
              </span>
            </div>
          </>
        )}
    </>
  );
};
const GroupBySection = ({ action, widgetFormik, dimensionList, measures }) => {
  const [aggrCountArr, setAggrCountArr] = useState([]);
  const [isChange, setIsChange] = useState(false);

  const handlePush = () => {
    const aggrCountArrCopy = [
      ...aggrCountArr,
      `report_group_aggr_${aggrCountArr.length}`,
    ];
    setAggrCountArr(aggrCountArrCopy);
  };
  const handlePop = index => {
    setIsChange(true);
    const aggrCountArrCopy = [...aggrCountArr];
    aggrCountArrCopy.splice(index, 1);
    const copy = widgetFormik?.values?.report_group_by_aggr;
    if (copy?.[`report_group_aggr_${index}`])
      delete copy[`report_group_aggr_${index}`];
    const aggrValues = Object.values(copy || {});
    const reportAggrObj = {};
    aggrCountArrCopy.forEach((e, i) => {
      reportAggrObj[`report_group_aggr_${i}`] = aggrValues[i];
    });
    widgetFormik.setFieldValue('report_group_by_aggr', reportAggrObj);
  };
  useEffect(() => {
    if (
      widgetFormik.values?.report_group_by_aggr &&
      Object.entries(widgetFormik.values?.report_group_by_aggr).length
    ) {
      setAggrCountArr(Object.keys(widgetFormik.values.report_group_by_aggr));
    } else setAggrCountArr([]);
    setIsChange(false);
  }, [widgetFormik.values?.report_group_by_aggr]);
  return (
    Array.isArray(dimensionList) &&
    dimensionList.length > 0 && (
      <>
        <div className="col-6 md:col-3">
          <span className="p-float-label">
            <Dropdown
              showClear
              filter
              id="groupByField"
              disabled={action === 'view' ? true : false}
              optionLabel={'value'}
              className="w-full"
              options={dimensionList}
              value={
                dimensionList.filter(
                  each =>
                    each.name ===
                    widgetFormik.values?.report_group_by?.dimension
                )?.[0]?.value
              }
              onChange={event => {
                const selectedLabel = event.value;

                const fullObject = dimensionList.find(
                  item => item.value === selectedLabel
                );
                if (fullObject?.name) {
                  widgetFormik.setFieldValue('report_group_by', {
                    alice: fullObject?.value,
                    dimension: fullObject?.name,
                    group_by_label: '',
                    primaryKeyMeasureName:
                      fullObject?.primaryKeyMeasures?.filter(
                        ({ aggType }) => aggType === 'count'
                      )?.[0]?.name,
                  });
                } else {
                  widgetFormik.setFieldValue('report_group_by', null);
                }
              }}
            />
            <label htmlFor="groupByField">Group By Field</label>
          </span>
        </div>
        <div className="col-6 md:col-3">
          <span className="p-float-label">
            <InputText
              className="w-full"
              id="group_by_label"
              value={widgetFormik.values?.report_group_by?.group_by_label || ''}
              onChange={event => {
                widgetFormik.setFieldValue('report_group_by', {
                  ...widgetFormik.values?.report_group_by,
                  group_by_label: event?.target?.value,
                });
              }}
              disabled={action === 'view' ? true : false}
            />
            <label htmlFor="groupByField">Group By Label</label>
          </span>
        </div>

        {!isChange &&
          widgetFormik.values?.report_group_by &&
          Array.isArray(measures) && (
            <>
              {aggrCountArr.length > 0 ? (
                aggrCountArr.map((e, i) => (
                  <div className="grid grid-nogutter w-full gap-2" key={i}>
                    <AggregationSection
                      aggrName={`report_group_aggr_${i}`}
                      measures={measures}
                      action={action}
                      widgetFormik={widgetFormik}
                    />
                    <div className="col-1 flex gap-1 justify-content-center align-items-center">
                      {action !== 'view' && (
                        <>
                          {i === aggrCountArr.length - 1 &&
                            aggrCountArr.length < 3 && (
                              <BadgePlus
                                className="text-primary text-sm w-1rem h-1rem"
                                onClick={handlePush}
                              />
                            )}
                          <BadgeMinus
                            className="text-primary text-sm w-1rem h-1rem"
                            fontSize="large"
                            onClick={() => handlePop(i)}
                          />
                        </>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-6 md:col-3">
                  <Button
                    icon={<PlusCircleIcon className="text-sm w-1rem h-1rem" />}
                    pt={{ label: { className: 'pl-1 text-xs' } }}
                    label="Add Aggregate (max 3 allowed)"
                    className={`border-round-md py-2`}
                    variant="outlined"
                    onClick={handlePush}
                  ></Button>
                </div>
              )}
            </>
          )}
      </>
    )
  );
};

export default GroupBySection;
